import React from 'react';

import styled from '@emotion/styled';

import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import TableGroup from '../../../components/Table/TableGroup';
import ActiveDriversList from './ActiveDriversList';
import ExitedDriversList from './ExitedDriversList';

const DriverList = () => {
  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <Container>
          <PageHeader title='Driver List' />

          <TableGroup titles={['Drivers', 'Exited Drivers']}>
            <ActiveDriversList />
            <ExitedDriversList />
          </TableGroup>
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
